<template>
    <v-container>
        <v-row v-if="liveMeets.length > 0">
            <v-col cols="12">
                <h1>Live Meets</h1>
            </v-col>
        </v-row>

        <v-row v-if="liveMeets.length > 0">
            <v-col cols="12">
                <v-row>
                    <v-col v-for="meet in liveMeets" :key="meet.id" cols="12" sm="12" md="6" lg="6">
                        <meet-card :meet="meet" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="meetsAndAds.length > 0">
            <v-col cols="12">
                <h1>Upcoming</h1>
            </v-col>
        </v-row>

        <v-row v-if="meetsAndAds.length > 0">
            <v-col cols="12">
                <v-row>
                    <v-col v-for="meetOrAd in meetsAndAds" :key="meetOrAd.id" cols="12" sm="12" md="6" lg="6">
                        <advertisement-card v-if="meetOrAd.advertiser_id" :advertisement="meetOrAd" />
                        <meet-card v-else :meet="meetOrAd" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="recentlyConcluded.length > 0">
            <v-col cols="12">
                <h1>Recently Concluded</h1>
            </v-col>
        </v-row>

        <v-row v-if="recentlyConcluded.length > 0">
            <v-col cols="12">
                <v-row>
                    <v-col v-for="meet in recentlyConcluded" :key="meet.id" cols="12" sm="12" md="6" lg="6">
                        <meet-card :meet="meet" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- View all meets -->
        <v-row>
            <v-col cols="12" class="text-right">
                <inertia-link :href="$route('meets.index')" class="text-decoration-none text-h6">
                    View All Meets
                    <v-icon class="ml-2">mdi-arrow-right-circle-outline</v-icon>
                </inertia-link>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <h1>What's New</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card
                    v-for="newFeature in newFeatures"
                    :id="`new-feature-${newFeature.id}`"
                    :key="newFeature.id"
                    class="my-4"
                >
                    <v-card-title style="word-break: break-word">
                        <span v-if="newFeature.icon" role="img" aria-label="Confetti" class="mr-1">
                            <v-icon>{{ newFeature.icon }}</v-icon>
                        </span>
                        <a v-if="newFeature.link" :href="newFeature.link">{{ newFeature.title }}</a>
                        <span v-else>{{ newFeature.title }}</span>

                        <v-spacer />
                        <span
                            class="grey--text text--darken-1"
                            :title="$moment.utc(newFeature.updated_at).tz($moment.tz.guess()).format('LLL zz')"
                        >
                            {{ $moment.utc(newFeature.updated_at).fromNow() }}
                        </span>
                    </v-card-title>

                    <v-card-text>
                        <div v-html="newFeature.content"></div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageMixin from '@/Pages/Page.mixin.js';
import MeetCard from '@/Components/MeetCard.vue';
import AdvertisementCard from '@/Components/AdvertisementCard.vue';

export default {
    name: 'Dashboard',

    components: {
        AdvertisementCard,
        MeetCard,
    },

    mixins: [PageMixin],

    props: {
        liveMeets: {
            type: Array,
            required: true,
        },

        upcomingMeets: {
            type: Array,
            required: true,
        },

        recentlyConcluded: {
            type: Array,
            required: true,
        },

        ads: {
            type: Array,
            required: true,
        },

        newFeatures: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    computed: {
        meetsAndAds() {
            if (!this.ads || !this.ads.length) {
                return this.upcomingMeets;
            }

            return [this.upcomingMeets[0], ...this.ads.slice(0, 2), ...this.upcomingMeets.slice(1)];
        },
    },

    methods: {},
};
</script>

<style>
.responsive-video {
    overflow: hidden;
    /* Optional: Sets a max width where the video should not grow beyond, you can adjust or remove this */
    max-width: 720px;
    /* This makes the container maintain the aspect ratio */
    position: relative;
    padding-bottom: 75%; /* Adjust this value based on your video's aspect ratio (height / width * 100%) */
}
.responsive-video video,
.responsive-video iframe {
    /* Makes the video fill the container */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
